import React from 'react';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale } from 'chart.js'
import { Bar } from 'react-chartjs-2'

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
)


const PayrollChart = ({totalSalary, totalDeduction}) => {
    const data = {
        labels: ['January', 'February', 'March', 'April', 'May', 
        'June', 'July', 'Aughust', 'September', 'October', 'November', 'December'],
        datasets: [{
                label: 'Income Statistic',
                data: totalSalary,
                borderWidth: 1,
                backgroundColor: "rgb(25,145,235)",
                borderRadius: '10px',
            },
            {
                label: 'Deduction',
                data: totalDeduction,
                backgroundColor: "rgb(131,130,222)",
                borderWidth: 1,
            }]
        }
    
    const options = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    fontSize: 16,
                }
            },
            title: {
                display: true,
                text: 'Income and Deduction Statistics', 
                position: 'top',
                fontSize: 20,
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                max: 150000, 
                ticks: {
                    callback: function (value) {
                        return '₦' + value;
                    },
                },
                
            },
        },
    
    }

  return (
    <div className="payroll__chart-info">
        <div className="payroll__chart-heading">
            <h4 className="payroll__chart-title">
                Payroll Summary
            </h4>
            <div className='payroll__chart-item'>
                <span className='payroll__chart-label'>
                    <span></span>
                    Net Salary
                </span>
                <span className='payroll__chart-label'>
                    <span></span>
                    Deduction
                </span>
            </div>
        </div>
        <div className="payroll__chart-box"> 
            <Bar data={data} options={options} width={1000}/>;
        </div>
    </div>
  )
};

export default PayrollChart;
